import { DefaultLayout, AuthLayout } from '@/layouts/index';

const pagesPrefix = '/pages';

const redirectRoutes = [
  {
    path: `/auth/line-redirect`,
    name: "LineRedirect",
    component: () => import("@/views/auth/LineRedirect.vue"),
    meta: { title: "Redirect..", authRequired: false },
  },
  {
    path: "/auth/thaid/callback",
    name: "ThaiDCallback",
    component: () => import("@/views/auth/ThaiDCallback.vue"),
    meta: { title: 'ThaiD Callback', authRequired: false },
  },
  {
    path: "/auth/thaid/mobile/callback",
    name: "ThaiDMobileCallback",
    component: () => import("@/views/auth/ThaiDMobileCallback.vue"),
    meta: { title: 'ThaiD Mobile Callback', authRequired: false },
  },
  {
    path: "/auth/apple/callback",
    name: "AppleCallback",
    component: () => import("@/views/auth/AppleCallback.vue"),
    meta: { title: 'Apple Callback', authRequired: false },
  },
  {
    path: "/auth/apple/result",
    name: "AppleResult",
    component: () => import("@/views/auth/AppleCallback.vue"),
    meta: { title: 'Apple Result', authRequired: false },
  },
].map((data) => {
  return {
    ...data,
    meta: { ...data.meta },
  };
});

const accountRoutes = [
  {
    path: `/`,
    name: 'AccountSignIn',
    component: () => import('@/views/account/SignIn.vue'),
    meta: { title: 'Sign In', authRequired: false },
  },
  {
    path: `/signup`,
    name: 'AccountSignUp',
    component: () => import('@/views/account/SignUp.vue'),
    meta: { title: 'Sign Up', authRequired: false },
  },
  // {
  //   path: `/verify-otp`,
  //   name: 'AccountVerify',
  //   component: () => import('@/views/account/VerifyOtp.vue'),
  //   meta: { title: 'Verify OTP', authRequired: false },
  // },
  {
    path: `/reset-password`,
    name: 'AccountResetPassword',
    component: () => import('@/views/account/ResetPassword.vue'),
    meta: { title: 'Reset Password', authRequired: false },
  },
  {
    path: `/create-password`,
    name: 'AccountChangePassword',
    component: () => import('@/views/account/CreatePassword.vue'),
    meta: { title: 'Create New Password', authRequired: false },
  },

].map((data) => {
  return {
    ...data,
    meta: { ...data.meta, layout: AuthLayout },
  };
});

const pagesRoutes = [
  {
    path: `${pagesPrefix}/maintenance`,
    name: 'PagesMaintenance',
    component: () => import('@/views/pages/Maintenance.vue'),
    meta: { title: 'Maintenance', authRequired: false, layout: AuthLayout },
  },
  {
    path: `${pagesPrefix}/coming-soon`,
    name: 'PagesComingSoon',
    component: () => import('@/views/pages/ComingSoon.vue'),
    meta: { title: 'Coming Soon', authRequired: false, layout: AuthLayout },
  },
].map((data) => {
  return {
    ...data,
    meta: { ...data.meta, layout: DefaultLayout },
  };
});

const policyRoutes = [
  {
    path: '/caat-connect/privacy-policy',
    name: 'CAATConnectPrivacyPolicy',
    component: () => import('@/views/policy/PrivacyPolicy.vue'),
    meta: { title: 'CAAT-Connect Privacy Policy', authRequired: false, layout: AuthLayout },
  },
].map((data) => {
  return {
    ...data,
    meta: { ...data.meta, layout: AuthLayout },
  };
});

export const routes = [
  ...redirectRoutes,
  ...accountRoutes,
  ...pagesRoutes,
  ...policyRoutes,
  {
    path: '/logout',
    name: 'Logout',
    component: () => import('@/views/account/Logout.vue'),
    meta: { title: 'Logout', authRequired: false },
  },

  {
    path: '/:pathMatch(.*)*',
    name: 'notfound',
    component: () => import('@/views/pages/PageNotfound.vue'),
  },
];
